import styled from 'styled-components';

export const SMapWrapper = styled.div`
  position: relative;
  display: flex;
  height: 336px;
  overflow: hidden;
  border-radius: 10px;

  .searchWithButton {
    top: 1rem;
  }
`;
